import {ZIM} from 'zego-zim-web';
import ConnectionState = ZIM.ConnectionState;

/**
 * Utility to check if the current user agent corresponds to a mobile device.
 * Adheres to SRP (Single Responsibility Principle) and facilitates testing.
 */
export function isMobileDevice(userAgent: string): boolean {
  // Standard regex for detecting mobile browsers
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(userAgent);
}

export function isNetworkBad(connectionState: ConnectionState) {
  return [ConnectionState.Disconnected, ConnectionState.Reconnecting].includes(connectionState);
}
